import React from 'react';

export const MainBanned = () => {

    return(
        <div className="center-container-holder">
            <div className="centered-container">
                <div className="center-holder">
                    <div className="title-holder">
                        <h1 className="title title-banned"><b>Sorry!</b></h1>
                    </div>
                    <div className="subtitle-holder">
                        <h3 className="subtitle subtitle-banned">Your account doesn’t meet the requirements to join our waitlist</h3>
                        <div className="requirements-holder">
                            <ul className="requirements-ul">
                                <li className="howitworks-text">Only fully verified accounts are eligible to join the waitlist</li>
                                <li className="howitworks-text">No burners allowed, make sure to use your main account</li>
                                <li className="howitworks-text">Previously banned users can't join Infinit</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
};